// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  background: #e6e8ea;
}

.flight-planning {
  display: flex;
  flex-direction: row-reverse;
  width: 100vw;
  height: 100vh;
}

.form-type-selection {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 70px;
  font-size: 15px;
}

.form-type-selection .choice-not-selected {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 100%;
  color: white;

  background-color: #0024c7;
  cursor: pointer;
}

.form-type-selection .choice-selected {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  height: 100%;
  color: black;
  background: linear-gradient(180deg, #399ffd 90%, #8de796 90%);
}

.form-content {
  width: 100%;
  height: 92.5%;
  padding: 5px 0px;
}

.form-content .input-section {
  margin: 10px auto 10px auto;
  width: 90%;
  height: 80px;
}

.form-content .special-input-section {
  margin: 10px auto 10px auto;
  width: 90%;
  height: 80px;
}

.form-content .input-section h5 {
  font-size: 15px;
}

.form-content .special-input-section h5 {
  font-size: 15px;
}

.form-content .input-section select {
  padding: 0px 10px;
  height: 40px;
  width: 100%;
  font-size: 20px;
  background-color: #f4f4f4;
  border-width: 0px;
  border-radius: 100px;
}

.form-content .input-section input {
  padding: 0px 20px;
  height: 40px;
  width: 100%;
  font-size: 20px;
  background-color: #f4f4f4;
  border-width: 0px;
  border-radius: 100px;
}

.form-content .button-section {
  margin: 35px auto 50px auto;
  width: 90%;
  height: 20px;
}

.form-content .button-section button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 100%;
  font-size: 15px;
  background-color: #92f1a1;
  border-width: 0px;
  border-radius: 100px;
}

@media screen and (max-width: 1024px) {
  .flight-planning {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/user/operation/FlightPlanning.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,YAAY;;EAEZ,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":["body {\r\n  margin: 0;\r\n  padding: 0;\r\n  background: #e6e8ea;\r\n}\r\n\r\n.flight-planning {\r\n  display: flex;\r\n  flex-direction: row-reverse;\r\n  width: 100vw;\r\n  height: 100vh;\r\n}\r\n\r\n.form-type-selection {\r\n  display: flex;\r\n  flex-direction: row;\r\n  width: 100%;\r\n  height: 70px;\r\n  font-size: 15px;\r\n}\r\n\r\n.form-type-selection .choice-not-selected {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 50%;\r\n  height: 100%;\r\n  color: white;\r\n\r\n  background-color: #0024c7;\r\n  cursor: pointer;\r\n}\r\n\r\n.form-type-selection .choice-selected {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 50%;\r\n  height: 100%;\r\n  color: black;\r\n  background: linear-gradient(180deg, #399ffd 90%, #8de796 90%);\r\n}\r\n\r\n.form-content {\r\n  width: 100%;\r\n  height: 92.5%;\r\n  padding: 5px 0px;\r\n}\r\n\r\n.form-content .input-section {\r\n  margin: 10px auto 10px auto;\r\n  width: 90%;\r\n  height: 80px;\r\n}\r\n\r\n.form-content .special-input-section {\r\n  margin: 10px auto 10px auto;\r\n  width: 90%;\r\n  height: 80px;\r\n}\r\n\r\n.form-content .input-section h5 {\r\n  font-size: 15px;\r\n}\r\n\r\n.form-content .special-input-section h5 {\r\n  font-size: 15px;\r\n}\r\n\r\n.form-content .input-section select {\r\n  padding: 0px 10px;\r\n  height: 40px;\r\n  width: 100%;\r\n  font-size: 20px;\r\n  background-color: #f4f4f4;\r\n  border-width: 0px;\r\n  border-radius: 100px;\r\n}\r\n\r\n.form-content .input-section input {\r\n  padding: 0px 20px;\r\n  height: 40px;\r\n  width: 100%;\r\n  font-size: 20px;\r\n  background-color: #f4f4f4;\r\n  border-width: 0px;\r\n  border-radius: 100px;\r\n}\r\n\r\n.form-content .button-section {\r\n  margin: 35px auto 50px auto;\r\n  width: 90%;\r\n  height: 20px;\r\n}\r\n\r\n.form-content .button-section button {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 40px;\r\n  width: 100%;\r\n  font-size: 15px;\r\n  background-color: #92f1a1;\r\n  border-width: 0px;\r\n  border-radius: 100px;\r\n}\r\n\r\n@media screen and (max-width: 1024px) {\r\n  .flight-planning {\r\n    flex-direction: column;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
